import React from "react";
import styled from "styled-components";

const ProgressBar = ({ value = 0, text, barColor }) => {
    return (
        <Container>
            <Bar progress value={value} barColor={barColor}>
                <Text progress>{text}</Text>
            </Bar>
            <Bar value={value}>
                <Text>{text}</Text>
            </Bar>
        </Container>
    );
};
export default ProgressBar;

const Container = styled.div`
    position: relative;
    display: flex;
    width: 500px;
    height: 25px;
    margin: 15px 0 25px 0;
    background-color: #fafafa;
    overflow:hidden;
    @media (max-width: 900px) {
        width: 300px;
    }
    box-shadow:0 4px 10px -5px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
`
const Bar = styled.div`
    position: absolute;
    top: 0;
    width: ${({progress, value}) => progress ? `${value}%` : `${100 - value}%`};
    height: 100%;
    background-color: ${({progress, barColor}) => progress ? barColor : '#fafafa'};
    transition: all .5s ease-in-out;
    ${({ progress }) => progress ? 'left: 0;' : 'right: 0;'}
    overflow: hidden;
`
const Text = styled.span`
    position:absolute;      
    display:flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 100%;
    border: 2px solid #cdcdcd;
    border-radius: 5px;
    font-size: 14px;
    line-height: .9em; /* 防止西文爆板 */
    text-align: center;
    ${({ progress }) => progress ? 'left: 0; color: #fff' : 'right: 0; color: #979797'}
    transition: all .5s ease-in-out;
    @media (max-width: 900px) {
        width: 300px;
        font-size: 12px;
    }
`


// WEBPACK FOOTER //
// ./src/dev/ProgressBar.js